import { get } from '../../../utils/api';

export default {
  getSliderList: () => get({ url: 'slider/list' }),
};
